
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {BModal} from "bootstrap-vue";

@Component
export default class ConfirmModal extends Vue {
    @Prop({required: true})
    id!: string;
    
    @Prop({required: true})
    title!: string;

    @Prop({required: true})
    actionButtonText!: string;

    @Prop({default: "primary"})
    buttonVariant!: string;
    
    $refs!: { bmodal: BModal }

    cancel() {
        this.$refs.bmodal.hide();
    }

    async confirmInner() {
        this.$emit('confirmed');
        this.$refs.bmodal.hide();
    }

    public show() {
        this.$refs.bmodal.show();
    }
}
